import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';

export interface IsRegionalOptionDirtyState {
    selectedLocale: string;
    selectedDateFormat: string;
    selectedTimeFormat: string;
    selectedTimeZone: string;
    savedLocale: string;
    savedDateFormat: string;
    savedTimeFormat: string;
    savedTimeZone: string;
}

export default select<IsRegionalOptionDirtyState>({
    selectedLocale: () => getRegionalOptions().selectedLocale,
    selectedDateFormat: () => getRegionalOptions().selectedDateFormat,
    selectedTimeFormat: () => getRegionalOptions().selectedTimeFormat,
    selectedTimeZone: () => getRegionalOptions().selectedTimeZone,
    savedLocale: () => getUserConfiguration().SessionSettings.UserCulture,
    savedDateFormat: () => getUserConfiguration().UserOptions.DateFormat,
    savedTimeFormat: () => getUserConfiguration().UserOptions.TimeFormat,
    savedTimeZone: () => getUserConfiguration().UserOptions.TimeZone,
})(function isRegionalOptionDirty(state?: IsRegionalOptionDirtyState) {
    let {
        selectedLocale,
        selectedDateFormat,
        selectedTimeFormat,
        selectedTimeZone,
        savedLocale,
        savedDateFormat,
        savedTimeFormat,
        savedTimeZone,
    } = state;

    return (
        (selectedLocale !== null && selectedLocale !== savedLocale) ||
        (selectedDateFormat !== null && selectedDateFormat !== savedDateFormat) ||
        (selectedTimeFormat !== null && selectedTimeFormat !== savedTimeFormat) ||
        (selectedTimeZone !== null && selectedTimeZone !== savedTimeZone)
    );
});
